import { messageEmits as Z, messageProps as W, MESSAGE_DEFAULT_PLACEMENT as j } from "./index693.js";
import { defineComponent as q, ref as v, computed as a, onMounted as J, watch as K, openBlock as l, createBlock as m, Transition as Q, unref as o, withCtx as C, withDirectives as X, createElementVNode as S, normalizeStyle as Y, normalizeClass as r, createCommentVNode as d, resolveDynamicComponent as _, renderSlot as ee, createElementBlock as L, toDisplayString as te, Fragment as oe, withModifiers as ne, createVNode as se, vShow as ae, nextTick as le } from "vue";
import { useEventListener as re, useResizeObserver as ie } from "./index562.js";
import { ElBadge as ue } from "./index602.js";
import { ElIcon as w } from "./index538.js";
import { getLastOffset as me, getOffsetOrSpace as ce } from "./index759.js";
import { TypeComponentsMap as x, TypeComponents as fe } from "./index606.js";
import { useGlobalComponentSettings as ve } from "./index620.js";
import { getEventCode as de } from "./index589.js";
import { EVENT_CODE as pe } from "./index590.js";
import { useTimeoutFn as ye } from "./index599.js";
const ge = ["id"], Ce = ["innerHTML"];
var Ne = /* @__PURE__ */ q({
  name: "ElMessage",
  __name: "message",
  props: W,
  emits: Z,
  setup(n, { expose: B, emit: N }) {
    const { Close: z } = fe, e = n, O = N, E = v(!1), { ns: t, zIndex: D } = ve("message"), { currentZIndex: I, nextZIndex: $ } = D, p = v(), c = v(!1), T = v(0);
    let y;
    const A = a(
      () => e.type ? e.type === "error" ? "danger" : e.type : "info"
    ), R = a(() => {
      const s = e.type;
      return { [t.bm("icon", s)]: s && x[s] };
    }), h = a(
      () => e.icon || x[e.type] || ""
    ), i = a(() => e.placement || j), V = a(() => me(e.id, i.value)), b = a(() => ce(e.id, e.offset, i.value) + V.value), F = a(() => T.value + b.value), H = a(() => i.value.includes("left") ? t.is("left") : i.value.includes("right") ? t.is("right") : t.is("center")), k = a(
      () => i.value.startsWith("top") ? "top" : "bottom"
    ), P = a(() => ({
      [k.value]: `${b.value}px`,
      zIndex: I.value
    }));
    function g() {
      e.duration !== 0 && ({ stop: y } = ye(() => {
        f();
      }, e.duration));
    }
    function M() {
      y?.();
    }
    function f() {
      c.value = !1, le(() => {
        var s;
        E.value || ((s = e.onClose) == null || s.call(e), O("destroy"));
      });
    }
    function G(s) {
      de(s) === pe.esc && f();
    }
    return J(() => {
      g(), $(), c.value = !0;
    }), K(
      () => e.repeatNum,
      () => {
        M(), g();
      }
    ), re(document, "keydown", G), ie(p, () => {
      T.value = p.value.getBoundingClientRect().height;
    }), B({
      visible: c,
      bottom: F,
      close: f
    }), (s, u) => (l(), m(Q, {
      name: o(t).b("fade"),
      onBeforeEnter: u[0] || (u[0] = (U) => E.value = !0),
      onBeforeLeave: n.onClose,
      onAfterLeave: u[1] || (u[1] = (U) => s.$emit("destroy")),
      persisted: ""
    }, {
      default: C(() => [
        X(S("div", {
          id: n.id,
          ref_key: "messageRef",
          ref: p,
          class: r([
            o(t).b(),
            { [o(t).m(n.type)]: n.type },
            o(t).is("closable", n.showClose),
            o(t).is("plain", n.plain),
            o(t).is("bottom", k.value === "bottom"),
            H.value,
            n.customClass
          ]),
          style: Y(P.value),
          role: "alert",
          onMouseenter: M,
          onMouseleave: g
        }, [
          n.repeatNum > 1 ? (l(), m(o(ue), {
            key: 0,
            value: n.repeatNum,
            type: A.value,
            class: r(o(t).e("badge"))
          }, null, 8, ["value", "type", "class"])) : d("v-if", !0),
          h.value ? (l(), m(o(w), {
            key: 1,
            class: r([o(t).e("icon"), R.value])
          }, {
            default: C(() => [
              (l(), m(_(h.value)))
            ]),
            _: 1
            /* STABLE */
          }, 8, ["class"])) : d("v-if", !0),
          ee(s.$slots, "default", {}, () => [
            n.dangerouslyUseHTMLString ? (l(), L(
              oe,
              { key: 1 },
              [
                d(" Caution here, message could've been compromised, never use user's input as message "),
                S("p", {
                  class: r(o(t).e("content")),
                  innerHTML: n.message
                }, null, 10, Ce)
              ],
              2112
              /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */
            )) : (l(), L(
              "p",
              {
                key: 0,
                class: r(o(t).e("content"))
              },
              te(n.message),
              3
              /* TEXT, CLASS */
            ))
          ]),
          n.showClose ? (l(), m(o(w), {
            key: 2,
            class: r(o(t).e("closeBtn")),
            onClick: ne(f, ["stop"])
          }, {
            default: C(() => [
              se(o(z))
            ]),
            _: 1
            /* STABLE */
          }, 8, ["class"])) : d("v-if", !0)
        ], 46, ge), [
          [ae, c.value]
        ])
      ]),
      _: 3
      /* FORWARDED */
    }, 8, ["name", "onBeforeLeave"]));
  }
});
export {
  Ne as default
};
